import { Cell, CellType } from '../_base/table-cell.entity';

export class CheckboxCell extends Cell {
    constructor(
        public readonly rowId: string,
        public readonly startValue: boolean,
        public onToggleAction: (id: string) => void
    ) {
        super(CellType.CHECKBOX);
    }
}
